<template>
    <div class="h-full flex justify-center sm:justify-start flex-row gap-10 sm:flex-col sm:min-w-[200px] sm:max-w-[15rem] sm:gap-32">
        <img v-for="(event, index) in events" :src="event.cover.cached_url" :alt="event.name"
             class="rounded w-2/3 object-cover max-h-[120px] sm:w-full sm:max-h-full"
             :class="isDown ? 'odd:-mt-10' : 'odd:mt-10'"
             :key="index"
        />
    </div>
</template>

<script>
export default {
    name: "OrganismImagesLoading",
    props: {
        events: {
            type: Array,
            required: true
        },
        isDown: {
            type: Boolean,
            default: false
        }
    },
}


</script>


<style scoped>

</style>
